import { format } from 'date-fns';

export const formatDaysAgo = (daysAgo: number) => {
  const newDate = new Date();
  newDate.setDate(newDate.getDate() - Math.abs(Math.floor(daysAgo)));
  return format(newDate, 'yyyy-MM-dd');
};
